import css from './Preloader.module.scss';

const Preloader: React.FC = () => {
  return <div className={css.Preloader}></div>;
};

export default Preloader;
